import React, { Component } from 'react';
import Color from 'color';
import Field from './Field';
import Grid from './Grid';
import Output from './Output';
import Toggle from './Toggle';
import './App.css';

const types = [
  {
    'value': 'hsl',
    'text': 'HSL',
  },
  {
    'value': 'rgb',
    'text': 'RGB',
  },
];

export class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'hsl',
      defaultColor: 'white',
      contrastRatio: 4.5,
      hue: 220,
      saturation: 50,
      lightness: 50,
      // alpha: 100,
      r: 64,
      g: 106,
      b: 191,
    };
    this.changeValue = this.changeValue.bind(this);
  }
  
  changeValue(newValue, key) {
    this.setState({
      [key]: newValue
    });
  }

  render() {
    const {
      type,
      defaultColor,
      contrastRatio,
      hue,
      saturation,
      lightness,
      // alpha,
      r,
      g,
      b,
    } = this.state;
    const colors = {
      hsl: "hsl(" + hue + "," + saturation + "%," + lightness + "%)",
      rgb: "rgb(" + r + "," + g + "," + b + ")",
    }
    const color = Color(colors[type]);
    const mainColor = (color.contrast(Color(defaultColor))  > contrastRatio) ? defaultColor : 'black';
    const mainBackground = colors[type];
    return (
      <main className="app" style={{ color: mainColor, backgroundColor: mainBackground }}>
        <section>
          <h1>Color calculator</h1>
          <Toggle value={type} activeColor={mainBackground} select="type" options={types} onClick={this.changeValue}/>
          {type === 'hsl' && (
            <fieldset>
              <legend>HSL</legend>
              <Grid>
                <Field styles={{margin: 0}} select="hue" label="Hue" value={hue} type="number" min={0} max={359} step={5} onChange={this.changeValue} />
                <Field styles={{margin: 0}} select="saturation" label="Saturation" value={saturation} type="number" min={0} max={100} step={5} onChange={this.changeValue} />
                <Field styles={{margin: 0}} select="lightness" label="Lightness" value={lightness} type="number" min={0} max={100} step={5} onChange={this.changeValue} />
                {/*<Field styles={{margin: 0}} select="alpha" label="Alpha" value={alpha} type="number" min={0} max={100} step={5} onChange={this.changeValue} />*/}
              </Grid>
          </fieldset>
          )}
          {type === 'rgb' && (
            <fieldset>
              <legend>RGB</legend>
              <Grid>
                <Field styles={{margin: 0}} select="r" label="Red" value={r} type="number" min={0} max={255} step={1} onChange={this.changeValue} />
                <Field styles={{margin: 0}} select="g" label="Green" value={g} type="number" min={0} max={255} step={1} onChange={this.changeValue} />
                <Field styles={{margin: 0}} select="b" label="Blue" value={b} type="number" min={0} max={255} step={1} onChange={this.changeValue} />
                {/*<Field styles={{margin: 0}} select="alpha" label="Alpha" value={alpha} type="number" min={0} max={100} step={5} onChange={this.changeValue} />*/}
              </Grid>
            </fieldset>
          )}
          <fieldset>
            <legend>Output</legend>
            <Grid min="100%" max="1fr">
              <Output styles={{margin: 0}} select="hsl" label="hsl" value={color.hsl().round().string()} />
              <Output styles={{margin: 0}} select="rgb" label="rgb" value={color.rgb().round().string()} />
              <Output styles={{margin: 0}} select="hex" label="hex" value={color.hex()} />
            </Grid>
          </fieldset>
        </section>
      </main>
    );
  }
}

export default App;
